import { useQuery } from '@tanstack/react-query';
import {
  fetch_languages,
  fetch_vet_specializations,
  fetch_walker_specializations,
  type LookupOption,
} from './api';

/**
 * Reference-data queries. Cached aggressively (the lists change only when
 * an admin adds a row) and callers always pass a hard-coded fallback so the
 * forms still render if the lookup fetch fails.
 */
const STALE_MS = 5 * 60 * 1000;

export function use_walker_specializations(fallback: LookupOption[]) {
  const q = useQuery({
    queryKey: ['lookups', 'walker-specializations'],
    queryFn: fetch_walker_specializations,
    staleTime: STALE_MS,
    retry: 1,
  });
  return q.data && q.data.length > 0 ? q.data : fallback;
}

export function use_vet_specializations(fallback: LookupOption[]) {
  const q = useQuery({
    queryKey: ['lookups', 'vet-specializations'],
    queryFn: fetch_vet_specializations,
    staleTime: STALE_MS,
    retry: 1,
  });
  return q.data && q.data.length > 0 ? q.data : fallback;
}

export function use_languages(fallback: LookupOption[]) {
  const q = useQuery({
    queryKey: ['lookups', 'languages'],
    queryFn: fetch_languages,
    staleTime: STALE_MS,
    retry: 1,
  });
  return q.data && q.data.length > 0 ? q.data : fallback;
}
